import styled from "@emotion/styled";

export const StyleTransactionCardWrapper = styled.div`
  border-radius: 8px;
  /* box-shadow: ${(props: any) => props.theme.colors.boxShadow}; */
  border: 1px solid ${(props: any) => props.theme.orange.orange50};
  padding: 16px;
  display: flex;
  column-gap: 10px;
  max-width: 100%;
  overflow: auto;
`;

export const StyleTransactionCard = styled.div`
  width: 100%;
  border-right: 1px solid ${(props: any) => props.theme.orange.orange600};
  display: flex;
  column-gap: 10px;
  align-items: center;
  justify-content: center;
`;
